import { LaunchUniversal } from '@duxton-web/icons';
import { Button, Flex, Modal, Table } from '@duxton-web/ui';
import React from 'react';

import dynamicAttributesDataSet from 'data/dynamic-attributes-data-set.json';


// Columns of table for dynamic attributes in the modal
const DYNAMIC_ATTRIBUTES_TABLE_COLUMNS = [
  {
    dataIndex: 'key',
    rowScope: 'row',
    className: '',
    width: 58,
  },
  {
    dataIndex: 'paxID',
    title: 'PAX ID',
    width: 183,
  },
  {
    dataIndex: 'content',
    title: 'Content',
    width: 427,
  },
  {
    dataIndex: 'referenceDate',
    title: 'Reference date',
    width: 183,
  },
];

const SmartCampaignDynamicAttributesModal = ({
  attributeModalInfo,
  setAttributeModalInfo,
}) => {
  const { isModalOpen, selectedAttribute } = attributeModalInfo;
  return (
    <Modal
      title={
        <Flex>
          <Flex vertical style={{ width: 624 }}>
            <span>{`Example of ${(selectedAttribute || '').toLowerCase()}`}</span>
          </Flex>
          {/* TODO: Need to add link to feedback */}
          <Button size="middle" disabled onClick={() => {}}>
            Give feedback
            <LaunchUniversal />
          </Button>
        </Flex>
      }
      open={isModalOpen}
      width={900}
      centered
      footer={null}
      style={{ height: '624px' }}
      onCancel={() => setAttributeModalInfo(false)}
      maskClosable={false}
    >
      <Table
        columns={DYNAMIC_ATTRIBUTES_TABLE_COLUMNS}
        dataSource={
          dynamicAttributesDataSet[selectedAttribute] &&
          dynamicAttributesDataSet[selectedAttribute].meta
        }
        size="large"
        pagination={false}
        scroll={{ y: 500 }}
        style={{ marginTop: 24 }}
      />
    </Modal>
  );
};
export default SmartCampaignDynamicAttributesModal;
